import { AppService } from './../../../../core/app.service';
import { Component, OnInit } from '@angular/core';
import { UiTable } from "../../../../components/ui/table/table.component";
import { NgIf } from '@angular/common';
import { TableExpressionBesoin } from '../../../../data/schemas/table.schema';
import { RouterLink } from "@angular/router";
import { routeAlias } from '../../../../../routesalias';
import { ExpressionBesoinService } from '../../../../services/expressionbesoin.service';
import { ExpressionBesoinRes } from '../../../../data/http/responses/expression.res';
import { ActiviteService } from '../../../../services/activite/activite.service';
import { MatIcon } from '@angular/material/icon';
import { UiButtonComponent } from '../../../../components/button/button.component';

@Component({
  selector: 'app-expression-besoin',
  imports: [UiTable, RouterLink, MatIcon, NgIf, UiButtonComponent],
  templateUrl: './expression-besoin.component.html',
  styleUrl: './expression-besoin.component.css'
})
export class ExpressionBesoinHomePage implements OnInit {
  public tableExpressionBesoin = TableExpressionBesoin;
  public routealias = routeAlias;
  public expressionBesoins: ExpressionBesoinRes[] = [];

  // ── État du dialog de suppression ──
  public deleteDialog = {
    isVisible: false,
    isLoading: false,
    confirmReady: false,
    countdown: 3,
    itemLabel: '',
    item: null as ExpressionBesoinRes | null,
  };

  private countdownInterval: any = null;

  constructor(
    private AppService: AppService,
    private expressionBesoinService: ExpressionBesoinService,
    private activiteService: ActiviteService
  ) {}

  ngOnInit(): void {
    this.loadExpressionBesoins();
  }

  hasAccess(roles?: string[]): boolean {
    if (!roles || roles.length === 0) return true;
    if (this.AppService['authService'] && typeof this.AppService['authService'].hasAnyRole === 'function') {
      return this.AppService['authService'].hasAnyRole(roles);
    }
    return false;
  }

  loadExpressionBesoins(): void {
    this.expressionBesoinService.getAllByAppId(this.AppService.getAppId()!).subscribe({
      next: (response: any) => {
        this.expressionBesoins = response.data;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des expressions de besoin :', error);
      }
    });
  }

  // ── Dialog de suppression ──

  openDeleteDialog(item: ExpressionBesoinRes): void {
    this.deleteDialog = {
      isVisible: true,
      isLoading: false,
      confirmReady: false,
      countdown: 3,
      itemLabel: (item as any).titre || (item as any).label || (item as any).nom || `#${item.id}`,
      item,
    };
    this.startCountdown();
  }

  private startCountdown(): void {
    this.clearCountdown();
    this.countdownInterval = setInterval(() => {
      this.deleteDialog.countdown--;
      if (this.deleteDialog.countdown <= 0) {
        this.deleteDialog.confirmReady = true;
        this.clearCountdown();
      }
    }, 1000);
  }

  private clearCountdown(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
  }

  cancelDelete(): void {
    this.clearCountdown();
    this.deleteDialog.isVisible = false;
    this.deleteDialog.item = null;
  }

  confirmDelete(): void {
    if (!this.deleteDialog.item || !this.deleteDialog.confirmReady) return;

    this.deleteDialog.isLoading = true;
    const id = this.deleteDialog.item.id;

    this.expressionBesoinService.delete(id).subscribe({
      next: () => {
        this.expressionBesoins = this.expressionBesoins.filter(e => e.id !== id);
        this.deleteDialog.isVisible = false;
        this.deleteDialog.isLoading = false;
        this.deleteDialog.item = null;
      },
      error: (error) => {
        console.error('Erreur lors de la suppression :', error);
        this.deleteDialog.isLoading = false;
      }
    });
  }

  getEditRouterLink(item: ExpressionBesoinRes): (string | number)[] {
    if (item.regroupements && item.regroupements.length > 0) {
      return [
        '/',
        this.routealias.marchees.home,
        this.routealias.marchees.expression_besoin.home,
        this.routealias.marchees.expression_besoin.regroupement_expression_besoin.home,
        routeAlias.marchees.expression_besoin.regroupement_expression_besoin.edit,
        item.id
      ];
    } else if (item.activites && item.activites.length > 0) {
      return [
        '/',
        routeAlias.marchees.home,
        routeAlias.marchees.expression_besoin.home,
        routeAlias.marchees.expression_besoin.edit,
        item.id
      ];
    } else {
      return [
        '/',
        this.routealias.marchees.home,
        this.routealias.marchees.expression_besoin.home,
        this.routealias.marchees.expression_besoin.edit,
        item.id
      ];
    }
  }
}